import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'productos', namespaced: true })

export default mystore
